import { api } from 'utility';
import {
  getGuildServiceUrl,
  getPercentageVourhcerUrl,
  getAmountVouhcerUrl,
  getProductSearchUrl,
  getCarTableListUrl,
  cartableDiscountAmount,
  cartableDiscountPercentage
} from 'URLs';
// Cards
export function postPercentageVourhcer(data) {
  return api.post(getPercentageVourhcerUrl(), data).then((res) => res.data);
}

export function postAmountVourhcer(data) {
  return api.post(getAmountVouhcerUrl(), data).then((res) => res.data);
}

export function postCartableAmount(data) {
  return api.post(cartableDiscountAmount(), data).then((res) => res.data);
}

export function postCartablePercentage(data) {
  return api.post(cartableDiscountPercentage(), data).then((res) => res.data);
}

export function getProducts(params) {
  return api.get(getProductSearchUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export async function checkCartable(param) {
  return api.post(getCarTableListUrl(), param).then((res) => res.data);
}

export default {
  postPercentageVourhcer,
  postAmountVourhcer,
  getProducts,
  getGuildsList,
  checkCartable,
  postCartableAmount,
  postCartablePercentage
};
